var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "back-profile",
        {
          nativeOn: {
            click: function($event) {
              return _vm.navigateTo("app.profile.attentions")
            }
          }
        },
        [_vm._v("Volver a Atenciones")]
      ),
      _vm._v(" "),
      _c(
        "attentions-by-type-header",
        {
          staticStyle: { "padding-bottom": "25px", margin: "10px 0" },
          attrs: {
            "bordered-header": true,
            "total-pending": this.totalByType("PENDING"),
            "total-failed": this.totalByType("FAILED"),
            "total-completed": this.totalByType("COMPLETED")
          }
        },
        [
          _c("template", { slot: "header" }, [
            this.attentionsByType[0]
              ? _c("div", [
                  _vm._v(_vm._s(_vm.attentionTitle(this.attentionsByType[0])))
                ])
              : _vm._e()
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c("attentions-by-type-body", {
        attrs: { attentions: this.attentionByState() },
        on: { "finish-attention": _vm.finishAttention }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }